<template>
  <GeneralLayout>
    <div class="container-main">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12 p-0" >
            <div class="container-auth">
              <div class="container">
                <AuthenticationCardHeaderWidget/>
                <div class="row">
                  <div class="col-12">
                    <router-view/>
                  </div>
                </div>
              </div>
            </div>

            <AnnouncementAuthSidebarTemplate/>
          </div>
        </div>
      </div>
    </div>
  </GeneralLayout>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import GeneralLayout from '@shared/components/layouts/general.layout.vue';
import AuthenticationCardHeaderWidget
  from "@domains/auth/layouts/authentication-card-header.widget.vue";
import AnnouncementAuthSidebarTemplate
  from "@domains/auth/layouts/announcement-auth-sidebar.template.vue";


export default defineComponent({
  name: 'AuthenticationView',
  components: {
    GeneralLayout,
    AuthenticationCardHeaderWidget,
    AnnouncementAuthSidebarTemplate,
  },
  props: {
    msg: String,
  },
});

</script>

<style lang="scss">
.hidden {
  display: none;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.container-auth {
  position: absolute;
  z-index: 2;
  right: var(--space-64);
  top: 50%;
  transform: translateY(-50%);
  width: 420px;
  height: auto;
  background-color: var(--light-100);
  border-radius: $br-md-oval;
  box-shadow: var(--card-shadow-active);
  padding: var(--space-32);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  text-align: left;

  .logo {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-top: var(--space-32);
    margin-bottom: var(--space-64);
  }

  .headline {
    margin-bottom: 20px;
  }

  .small-text {
    &-center {
      font-size: var(--fs-14);
      color: var(--text-neutral);
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      margin: 20px 0;

      a {
        color: var(--text-neutral);
        border-bottom: 1px dotted var(--neutral-300);
      }
    }

    &-right {
      font-size: var(--fs-14);
      color: var(--text-neutral);
      display: flex;
      justify-content: flex-end;
      padding: 0;
      margin: 20px 0;

      a {
        color: var(--text-neutral);
      }
    }
  }

  .input-group {
    margin-bottom: 10px;
    height: 45px;
  }

  form {
    .form-control {
      background: transparent;
      padding: 0.375rem 1rem;
      border: 0;
      font-size: var(--fs-14);
      height: 41px;

      &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
        color: var(--neutral-200) !important;
      }

      &::-moz-placeholder { /* Firefox 19+ */
        color: var(--neutral-200) !important;
      }

      &:-ms-input-placeholder { /* IE 10+ */
        color: var(--neutral-200) !important;
      }

      &:-moz-placeholder { /* Firefox 18- */
        color: var(--neutral-200) !important;
      }
    }

    .form-check-input {
      border: 1px solid var(--neutral-200);
    }

    .form-check-label {
      font-size: var(--fs-14);
      color: var(--text-dark);
    }

    .form-check-label.checkbox {
      color: var(--text-dark);
      font-size: var(--fs-10);
    }
  }

  .password-meter {
    margin-bottom: 10px;
    text-align: center;

  }

  .po-password-strength-bar {
    border-radius: $br-sm;
    transition: all 0.2s linear;
    height: 5px;
    margin-top: 8px;
    background-color: var(--password-strength-default);
  }

  .po-password-strength-bar.risky {
    background-color: var(--password-strength-risky);
  }

  .po-password-strength-bar.guessable {
    background-color: var(--password-strength-guessable)
  }

  .po-password-strength-bar.weak {
    background-color: var(--password-strength-weak);
  }

  .po-password-strength-bar.safe {
    background-color: var(--password-strength-safe);
  }

  .po-password-strength-bar.secure {
    background-color: var(--password-strength-secure);
  }

  .alert-successful {
    color: var(--green-100);
    text-align: center;
    margin: 20px 0;
  }
}

</style>
